if (!customElements.get('custom-before-after')) {
  customElements.define(
    'custom-before-after',
    class CustomBeforeAfter extends HTMLElement {
      connectedCallback() {
        this.range = this.querySelector('.custom-before-after__range');
        if (!this.range) return;

        this.range.addEventListener('input', () => {
          this.style.setProperty('--custom-ba-position', `${this.range.value}%`);
        });
      }
    }
  );
}
